import { formatDate, maskName } from "@luce/core/utils";

import type { GiftCardByIdQuery } from "../../__generated__/graphql";
import { GiftCardStatusEnum } from "../../__generated__/graphql";

export type GiftCard = NonNullable<GiftCardByIdQuery["giftCard"]>;

export type GiftDetailView = "sent" | "received-redeemed" | "received-inactive";

export function resolveGiftDetailView(giftCard: GiftCard, clientId: string): GiftDetailView {
  if (giftCard.sender.id === clientId) return "sent";
  return giftCard.status === GiftCardStatusEnum.Redeemed
    ? "received-redeemed"
    : "received-inactive";
}

/** Status line under the "Status" overline on the sender view. */
export function sentStatusMessage(giftCard: GiftCard): string {
  switch (giftCard.status) {
    case GiftCardStatusEnum.PendingPayment:
      return "Waiting for payment";
    case GiftCardStatusEnum.Active:
      return "Waiting for recipient to redeem";
    case GiftCardStatusEnum.Redeemed:
      return `Redeemed by ${maskName(giftCard.recipient?.name ?? "")}`;
    case GiftCardStatusEnum.Expired:
      return "This gift has expired";
    case GiftCardStatusEnum.Cancelled:
      return "This gift was cancelled";
  }
}

export const formatExpiry = (date: string) => formatDate(new Date(date), "d MMM yyyy", true);

export const shareGiftCardMessage = (code: string, webDomain: string) =>
  `Hey! I got you a Luce gift card 🎁 Use code ${code} on the Luce app! Redeem here: ${webDomain}/profile/gift-card?redeem=${code}`;
